import TitleBar from './TitleBar';

export default TitleBar;
